import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { SystemMessageService } from 'app/core/system-message/system-message-service';
import { FinancialReportFilterVm } from '../../app/shared/generated/Report/Models/FinancialReportFilterVm'
import { saveAs } from 'file-saver';

@Component({
    selector: 'pcg-financial-report',
    templateUrl: './financial-report.component.html',
    styleUrls: ['./financial-report.component.scss'],
    standalone: false
})
export class FinancialReportComponent implements OnInit {

  formGroup = FinancialReportFilterVm.Form;
  model = FinancialReportFilterVm.GetModel(this.formGroup);

  constructor(private httpClient: HttpClient, private ms: SystemMessageService,) { }

  ngOnInit(): void {
    this.httpClient.get('api/Report/Report/GetFinancialReportFiltersVm')
      .subscribe((model: FinancialReportFilterVm) => {
        this.formGroup.patchValue(model);
      })
  }

  public generateReport() {
    const httpOptions = {
      responseType: 'blob' as 'json',
      params: new HttpParams().set("monthYearString", this.formGroup.get('monthYearString').value)
    };

    let month: string = (this.formGroup.get('monthYearString').value as string).split(' ')[1];
    let year: string = (this.formGroup.get('monthYearString').value as string).split(' ')[0];
    let date = new Date();
    date.setMonth((+month) - 1);
    date.setFullYear(+year);
    let dateString = date.toLocaleDateString("default", { month: "long", year: "numeric" });

    this.httpClient.get('api/Report/Report/GenerateFinancialReport', httpOptions).subscribe((data: any) => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const file = new File([blob], `${dateString} Financial Report`, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      this.ms.setSystemMessage("Excel generated successfully.");
      saveAs(file);
    });
  }
}
